var React = require('react');

function Time (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"10","cy":"10","r":"9.5","fill":"#959595","stroke":"#959595","key":0}),React.createElement("path",{"d":"M14 4C16.5 5.5 17.2793 7.28597 17.5 10H10.5359L14 4Z","fill":"white","key":1})]);
}

Time.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Time;

Time.default = Time;
